package com.sweetlime.bingeamigo.presentation.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.sweetlime.bingeamigo.presentation.ui.BrandColors

/**
 * Pill segmented control shared by Search and Library.
 *
 * @param accent the colour of the active pill (amber for primary filters, teal for
 *        the Library sub-filters per the "teal = state/tracking" rule).
 * @param accentInk text colour on the active pill.
 * @param filled when true the active pill is a solid fill; when false it's a tinted
 *        outline (used for the Library count tiles).
 */
@Composable
fun SegmentedPills(
    options: List<String>,
    selected: String,
    onSelect: (String) -> Unit,
    modifier: Modifier = Modifier,
    accent: Color = BrandColors.Primary,
    accentInk: Color = Color(0xFF1A1407),
    height: Int = 38,
    filled: Boolean = true,
) {
    Row(modifier = modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
        options.forEach { opt ->
            val active = opt == selected
            val bg = when {
                active && filled -> accent
                active && !filled -> accent.copy(alpha = 0.13f)
                else -> BrandColors.Card
            }
            val fg = when {
                active && filled -> accentInk
                active && !filled -> accent
                else -> BrandColors.TextSecondary
            }
            Surface(
                onClick = { onSelect(opt) },
                modifier = Modifier.weight(1f).height(height.dp),
                shape = RoundedCornerShape(11.dp),
                color = bg,
                border = androidx.compose.foundation.BorderStroke(
                    1.dp, if (active) accent else Color(0xFF2A2A2E),
                ),
            ) {
                Box(contentAlignment = Alignment.Center) {
                    Text(opt, color = fg, fontWeight = FontWeight.Bold, fontSize = 13.5.sp)
                }
            }
        }
    }
}
